exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-create-profile-js": () => import("./../../../src/pages/create-profile.js" /* webpackChunkName: "component---src-pages-create-profile-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-order-complete-js": () => import("./../../../src/pages/order-complete.js" /* webpackChunkName: "component---src-pages-order-complete-js" */),
  "component---src-pages-sales-js": () => import("./../../../src/pages/sales.js" /* webpackChunkName: "component---src-pages-sales-js" */)
}

